import React from "react";

interface ThoughtLeadershipCardSkeletonProps {
  className?: string;
}

const ThoughtLeadershipCardSkeleton: React.FC<ThoughtLeadershipCardSkeletonProps> = ({ className = "" }) => {
  return (
    <div className={`w-full bg-transparent overflow-hidden animate-pulse ${className}`}>
      {/* Top Image Skeleton */}
      <div className="relative w-full h-[260px] overflow-hidden bg-gray-200 rounded-t-lg">
        <div className="absolute inset-0 bg-gradient-to-r from-gray-200 via-gray-100 to-gray-200 animate-pulse"></div>
      </div>

      {/* Content Card Skeleton */}
      <div className="m-4">
        <div className="bg-white/80 backdrop-blur-md px-6 py-4 -mt-16 relative z-50 shadow-[0_4px_8px_0_rgba(0,0,0,0.03)]">
          {/* Date & Category Skeleton */}
          <div className="flex justify-between items-center mb-2">
            <div className="h-4 bg-gray-200 rounded w-16 animate-pulse"></div>
            <div className="h-4 bg-gray-200 rounded w-20 animate-pulse"></div>
          </div>

          {/* Title Skeleton */}
          <div className="space-y-2 mb-2">
            <div className="h-5 bg-gray-200 rounded w-full animate-pulse"></div>
            <div className="h-5 bg-gray-200 rounded w-3/4 animate-pulse"></div>
          </div>

          {/* Excerpt Skeleton */}
          <div className="space-y-1">
            <div className="h-3 bg-gray-100 rounded w-full animate-pulse"></div>
            <div className="h-3 bg-gray-100 rounded w-5/6 animate-pulse"></div>
            <div className="h-3 bg-gray-100 rounded w-4/6 animate-pulse"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ThoughtLeadershipCardSkeleton;

